module.exports = __webpack_public_path__ + "img/step5.995fdcf2.png";